export function svgToPng(
  svgString: string,
  width: number,
  height: number
): Promise<Blob | null> {
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  svgString = setSvgDimensions(svgString, width, height);

  const image = new Image();

  image.src = "data:image/svg+xml;utf8," + encodeURIComponent(svgString);

  return new Promise<Blob | null>((resolve) => {
    image.onload = () => {
      canvas.getContext("2d")?.drawImage(image, 0, 0);
      canvas.toBlob(resolve);
    };
  });
}

function setSvgDimensions(svgString: string, width: number, height: number) : string {
  const parser = new DOMParser();
  const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');
  const svg = svgDoc.getElementsByTagName('svg')[0];
  svg?.setAttribute('width', width.toString());
  svg?.setAttribute('height', height.toString());

  return new XMLSerializer().serializeToString(svgDoc);
}